import { render, staticRenderFns } from "./fraude.vue?vue&type=template&id=da718a06&scoped=true"
import script from "./fraude.vue?vue&type=script&lang=js"
export * from "./fraude.vue?vue&type=script&lang=js"
import style0 from "./fraude.vue?vue&type=style&index=0&id=da718a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da718a06",
  null
  
)

export default component.exports